<ion-card>
  <ion-card-content>
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col
          size="12"
          size-lg="2"
        >
          <ion-skeleton-text
            [animated]="true"
            style="width: 50%; height: 1rem"
          ></ion-skeleton-text>
        </ion-col>
        <ion-col
          size="6"
          size-lg="4"
        >
          <ion-skeleton-text
            [animated]="true"
            style="width: 50%; height: 1rem"
          ></ion-skeleton-text>
          <ion-skeleton-text
            [animated]="true"
            style="width: 66%; height: 0.75rem"
          ></ion-skeleton-text>
          <ion-skeleton-text
            [animated]="true"
            style="width: 40%; height: 0.75rem"
          ></ion-skeleton-text>
        </ion-col>
        <ion-col
          size="6"
          size-lg="4"
        >
          <ion-skeleton-text
            [animated]="true"
            style="width: 50%; height: 1rem"
          ></ion-skeleton-text>
          <ion-skeleton-text
            [animated]="true"
            style="width: 40%; height: 0.75rem"
          ></ion-skeleton-text>
          <ion-skeleton-text
            [animated]="true"
            style="width: 66%; height: 0.75rem"
          ></ion-skeleton-text>
        </ion-col>
        <ion-col
          size-lg="2"
          class="ion-hide-lg-down"
        >
          <ion-skeleton-text
            [animated]="true"
            style="width: 50%; height: 1rem"
          ></ion-skeleton-text>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
